<div class="kt-container  kt-grid__item kt-grid__item--fluid">

    <!--Begin::Section-->
    <div class="row">
        <div class="col-xl-12">

            <!--begin:: Widgets/Applications/User/Profile3-->
            <div class="kt-portlet kt-portlet--height-fluid">
                <div class="kt-portlet__body">
                    <div class="kt-widget kt-widget--user-profile-3">
                        <div class="kt-widget__top">
                            <div class="kt-widget__media kt-hidden-">
                                <img class="kt-widget__img kt-hidden-" *ngIf="isImage"
                                    src="{{assetsPath + user.image}}" alt="image">
                                <img class="kt-widget__img kt-hidden-" *ngIf="!isImage"
                                    src="/assets/media/users/default.jpg" alt="image">
                            </div>
                            <div class="kt-widget__content">
                                <div class="kt-widget__head">
                                    <a href="#" class="kt-widget__username">
                                        {{ user.displayName}}
                                    </a>
                                    <div class="kt-widget__action">
                                        <a href="mailto:{{user.email}}"><button type="button" class="btn btn-label-success btn-sm btn-upper">MAİL AT</button></a>&nbsp;
                                        <button type="button" class="btn btn-label-primary btn-sm btn-upper" (click)="activate()">AKTİFLEŞTİR</button>&nbsp;
                                    </div>
                                </div>
                                <div class="kt-widget__subhead">
                                    <a href="#"><i class="flaticon2-new-email"></i>{{user.email}}</a>
                                    <a href="#"><i class="flaticon2-phone"></i>{{user.phone}} </a>
                                    <a href="#"><i class="flaticon2-placeholder"></i>{{user.primaryCity}}</a>
                                    <a href="#"><i class="flaticon2-calendar"></i>{{user.birthDate}}</a>
                                    <a href="#"><i class="flaticon2-check-mark"></i>{{user.isVerified ? 'Aktifleştirildi': 'Aktifleştirilmedi'}}</a>
                                </div>
                                <div class="kt-widget__info">
                                    <div class="kt-widget__desc">
                                        Merhaba, gönüllü detayını bu sayfada bulabilirsin.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--end:: Widgets/Applications/User/Profile3-->
        </div>
    </div>

    <!--End::Section-->
    <!--Begin::Section-->
    <div class="row">
        <div class="col-xl-6">

            <!--begin:: Widgets/Download Files-->
            <div class="kt-portlet kt-portlet--height-fluid">
                <div class="kt-portlet__head">
                    <div class="kt-portlet__head-label">
                        <h3 class="kt-portlet__head-title">
                            Eğitim Bilgileri
                        </h3>
                    </div>
                </div>
                <div class="kt-portlet__body">
                    <div class="kt-section kt-section--first">
                        <div class="kt-section__body">
                            <div class="row">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Okul</th>
                                            <th>Bölüm/Departman</th>
                                            <th>Öğrenim türü</th>
                                            <th>Başlangıç tarihi</th>
                                            <th>Bitiş tarihi</th>
                                            <th>Durum</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let education of user.education;">
                                            <td>{{ education.schoolName }}</td>
                                            <td>{{ education.departmant}}</td>
                                            <td>
                                                {{ getEducationLevel(education.level)}}
                                            </td>
                                            <td>{{ education.startDate}}</td>
                                            <td>{{ education.endDate}}</td>
                                            <td>
                                                {{ getStatus(education.isContinue)}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>

            <!--end:: Widgets/Download Files-->
        </div>
        <div class="col-xl-6">

            <!--begin:: Widgets/Download Files-->
            <div class="kt-portlet kt-portlet--height-fluid">
                <div class="kt-portlet__head">
                    <div class="kt-portlet__head-label">
                        <h3 class="kt-portlet__head-title">
                            Çalışma Bilgileri
                        </h3>
                    </div>
                </div>
                <div class="kt-portlet__body">
                    <div class="kt-section kt-section--first">
                        <div class="kt-section__body">
                            <div class="row">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Şirket</th>
                                            <th>Pozisyon</th>
                                            <th>Başlangıç tarihi</th>
                                            <th>Bitiş tarihi</th>
                                            <th>Durum</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let profession of user.profession;">
                                            <td>{{ profession.company }}</td>
                                            <td>{{ profession.position}}</td>
                                            <td>{{ profession.startDate}}</td>
                                            <td>{{ profession.endDate}}</td>
                                            <td>
                                                {{ getStatus(profession.isContinue)}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                   
                   
                </div>
            </div>

            <!--end:: Widgets/Download Files-->
        </div>
    </div>
    <div class="row">
        <div class="col-xl-3">

            <!--begin:: Widgets/Download Files-->
            <div class="kt-portlet kt-portlet--height-fluid">
                <div class="kt-portlet__head">
                    <div class="kt-portlet__head-label">
                        <h3 class="kt-portlet__head-title">
                            Gönüllü Rol Tercihleri
                        </h3>
                    </div>
                </div>
                <div class="kt-portlet__body">
                    <div class="kt-section kt-section--first">
                        <div class="kt-section__body">
                            <div class="row">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Seçilen rol</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let role of user.myRoles;">
                                            <td>{{ role.roleName }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>

            <!--end:: Widgets/Download Files-->
        </div>
        <div class="col-xl-9">

            <!--begin:: Widgets/Download Files-->
            <div class="kt-portlet kt-portlet--height-fluid">
                <div class="kt-portlet__head">
                    <div class="kt-portlet__head-label">
                        <h3 class="kt-portlet__head-title">
                            Gönüllü Etkinlik & Başvuru Geçmişi 
                        </h3>
                    </div>
                </div>
                <div class="kt-portlet__body">
                    <div class="kt-section kt-section--first">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Etkinlik adı</th>
                                    <th>Başvurulan pozisyon</th>
                                    <th>Başvuru tarihi</th>
                                    <th>Başvuru durumu</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let application of applications; index as i;">
                                    <td>{{i+1}}</td>
                                    <td>{{application.eventName}}</td>
                                    <td>{{application.roleName}}</td>
                                    <td>{{application.applicationDate}}</td>
                                    <td>{{getApplicationStatus(application.status)}}</td>
                                </tr>
                                <tr *ngIf="applications.length == 0">
                                    <td colspan="5" style="text-align: center;">Başvuru bulunmuyor</td>
                                </tr>
                            </tbody>
                        </table>
                </div>
            </div>

            <!--end:: Widgets/Download Files-->
        </div>
        
    </div>

    <div class="row">
        <div class="col-xl-6">

            <!--begin:: Widgets/Download Files-->
            <div class="kt-portlet kt-portlet--height-fluid">
                <div class="kt-portlet__head">
                    <div class="kt-portlet__head-label">
                        <h3 class="kt-portlet__head-title">
                            Hakem Bilgi Formu bilgileri
                        </h3>
                    </div>
                </div>
                <div class="kt-portlet__body" *ngIf="!isRefereeFilledBefore">
                    <div class="kt-section kt-section--first">
                        <div class="kt-section__body">
                            <div class="form-group">
                                <p>Formu doldurmamış.</p>
                            </div>
                        </div>
                    </div>
                   
                </div>
                <div class="kt-portlet__body" *ngIf="isRefereeFilledBefore">
                    <div class="kt-section kt-section--first">
                        <div class="kt-section__body">
                            <div class="form-group">
                                <h6>Turnuvaya katılan takımlarla herhangi bir bağınız var mı? (Sadece 2022-2023 SuperPowered sezonu için cevaplayınız.)</h6>
                                <p>{{ refereeForm.isConflict ? 'Evet': 'Hayır'}}</p>
                            </div>
                            <div class="form-group">
                                <h6>Daha önce Bilim Kahramanları Buluşuyor turnuvalarına katıldınız mı?</h6>
                                <p>{{ refereeForm.isVolunteeredBefore ? 'Evet': 'Hayır'}}</p>
                            </div>
                             <div class="form-group">
                                <h6>Cevabınız "Evet" ise rolünüz neydi?</h6>
                                <p>{{ refereeForm.volunteerExperience == '' ? '-': refereeForm.volunteerExperience }}</p>
                            </div>
                            <div class="form-group">
                                <h6>Bilim Kahramanları Derneği'nin diğer programlarında bulundunuz mu?</h6>
                                <p>{{ refereeForm.isOtherProgram ? 'Evet': 'Hayır'}}</p>
                            </div>
                            <div class="form-group">
                                <h6>Cevabınız "Evet" ise hangi programa katıldınız ve rolünüz neydi? (Örnek: Merak Makinesi - Gönüllü)</h6>
                                <p>{{ refereeForm.programExperience == '' ? '-': refereeForm.programExperience }}</p>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>

            <!--end:: Widgets/Download Files-->
        </div>
        <div class="col-xl-6">

            <!--begin:: Widgets/Download Files-->
            <div class="kt-portlet kt-portlet--height-fluid">
                <div class="kt-portlet__head">
                    <div class="kt-portlet__head-label">
                        <h3 class="kt-portlet__head-title">
                            Jüri Bilgi Formu bilgileri
                        </h3>
                    </div>
                </div>
                <div class="kt-portlet__body" *ngIf="!isJudgeFilledBefore">
                    <div class="kt-section kt-section--first">
                        <div class="kt-section__body">
                            <div class="form-group">
                                <p>Formu doldurmamış.</p>
                            </div>
                        </div>
                    </div>
                   
                </div>
                <div class="kt-portlet__body" *ngIf="isJudgeFilledBefore">
                    <div class="kt-section kt-section--first">
                        <div class="kt-section__body">
                            <div class="form-group">
                                <h6>Çıkar durumu var mı?</h6>
                                <p>{{ judgeForm.isConflict ? 'Evet': 'Hayır'}}</p>
                            </div>
                            <div class="form-group">
                                <h6>Daha önce herhangi bir gönüllülük tecrübeniz oldu mu?</h6>
                                <p>{{ judgeForm.isVolunteeredBefore ? 'Evet': 'Hayır'}}</p>
                            </div>
                             <div class="form-group">
                                <h6>Gönüllülük tecrübeniz olduysa
                                    detaylandırınız</h6>
                                <p>{{ judgeForm.volunteerExperience == '' ? '-': judgeForm.volunteerExperience }}</p>
                            </div>
                            <div class="form-group">
                                <h6>Daha önceki turnuvalarda jürilik yaptınız mı?</h6>
                                <p>{{ judgeForm.isJudgedBefore ? 'Evet': 'Hayır'}}</p>
                            </div>
                            <div class="form-group">
                                <h6>Hangi sezon(lar)da jüri oldunuz?</h6>
                                <p>{{ judgeForm.judgedTournaments == '' ? '-': judgeForm.judgedTournaments }}</p>
                            </div>
                            <div class="form-group">
                                <h6>Robotik kodlama tecrübeniz var mı?</h6>
                                <p>{{ judgeForm.isProgramming ? 'Evet': 'Hayır'}}</p>
                            </div>
                            <div class="form-group">
                                <h6>Bildiğiniz programlama dilleri
                                    nelerdir?</h6>
                                <p>{{ judgeForm.programmingLanguages == '' ? '-': judgeForm.programmingLanguages }}</p>
                            </div>
                            <div class="form-group">
                                <h6>Neden jüri olmak istiyorsunuz?</h6>
                                <p>{{ judgeForm.judgeExplanation }}</p>
                            </div>
                            <div class="form-group">
                                <h6>Bilim Kahramanları Derneği'nden bir
                                    referansınızı yazınız. (varsa)</h6>
                                <p>{{ judgeForm.reference == '' ? '-': judgeForm.reference }}</p>
                            </div>
                            <div class="form-group">
                                <h6>Formu doldurduğunuz için teşekkür ederiz. Ek
                                    görüşleriniz varsa lütfen yazınız.</h6>
                                <p>{{ judgeForm.additionalThoughts == '' ? '-': judgeForm.additionalThoughts }}</p>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>

            <!--end:: Widgets/Download Files-->
        </div>
    </div>

    <!--End::Section-->
</div>